import accordionFAQ from "../components/accordionFAQ"


const faq = _ => {
    accordionFAQ()
}

export default faq;